import { inject, Injectable } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { ContactDetailsFormGroup } from "../interfaces/forms/contact-details-form.interface";
import { AccountContactDetails } from "../interfaces/account-contact-details.interface";
import { phoneValidator } from "../validators/phone.validator";
import { AccountContactStatusDesc } from "../interfaces/account-contact-status-desc.interface";
import { YOrNDesc } from "../interfaces/y-or-n-desc.interface";
import { strictEmailValidator } from "../validators/strict-email.validator";

@Injectable({
  providedIn: 'root',
})
export class ContactDetailsFormService {
  fb = inject(FormBuilder);

  public form: ContactDetailsFormGroup;

  public init() {
    this.form = this.fb.group({
      status: [AccountContactStatusDesc.Active, Validators.required],
      isPrimaryContact: [false, Validators.required],
      contactFirstName: ['', Validators.required],
      contactLastName: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.maxLength(20), phoneValidator()]],
      emailAddress: ['', [Validators.required, Validators.maxLength(50), strictEmailValidator()]],
      receiveEmails: [true, [Validators.required]],
    });
  }

  public initFromContactDetails(contact: AccountContactDetails) {
    this.form = this.fb.group({
      status: [{ value: contact.statusDesc, disabled: true }],
      isPrimaryContact: [{ value: contact.isPrimaryContactDesc === YOrNDesc.Y, disabled: true }],
      contactFirstName: [contact.contactFirstName, Validators.required],
      contactLastName: [contact.contactLastName, Validators.required],
      phoneNumber: [contact.phoneNumber, [Validators.required, Validators.maxLength(20), phoneValidator()]],
      emailAddress: [{
        value: contact.emailAddress,
        disabled: true,
      }, [Validators.required, Validators.maxLength(50), strictEmailValidator()]],
      receiveEmails: [contact.receiveEmails, [Validators.required]],
    });
  }
}
